<template>
  <tr style="cursor: pointer">
    <td>{{ value.first_name }} {{ value.last_name }}</td>
    <td>{{ value.workstyle }}</td>
    <td>{{ `${value.total} (${value.total > 0 ? parseInt((value.total * 100) / 8) : 0}%)` }}</td>
    <td>{{ value.answer }}</td>
  </tr>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      showDetail: false
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/scgcareer/WorkStyle.vue